import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { AppLink, Reveal } from "@/components";
import { FEATURE, FEATURE_PANEL_BG } from "@/content";

export const Feature = () => (
  <Box as="section" maxW="maxw" mx="auto" px="pad" pb="sec">
    <Reveal>
      <Grid
        as="article"
        className="print-flat"
        borderRadius="lg"
        overflow="hidden"
        bg={FEATURE_PANEL_BG}
        color="ink.light"
        templateColumns={{ base: "1fr", md: "1.1fr 0.9fr" }}
        data-group
      >
        <Box as="figure" overflow="hidden">
          <img
            src={FEATURE.image.src}
            width={FEATURE.image.width}
            height={FEATURE.image.height}
            alt={FEATURE.image.alt}
            loading="lazy"
            decoding="async"
            style={{ width: "100%", height: "100%", aspectRatio: "16 / 11", objectFit: "cover" }}
          />
        </Box>

        <Grid gap="16px" alignContent="center" p="clamp(28px, 4vw, 60px)">
          {FEATURE.kicker && (
            <Text variant="eyebrowBrand" color="brand.500">
              {FEATURE.kicker}
            </Text>
          )}
          <Heading
            as="h2"
            variant="section"
            fontSize="clamp(1.75rem, 3.4vw, 3rem)"
            lineHeight={0.88}
            letterSpacing="normal"
          >
            {FEATURE.title}
          </Heading>
          <Text
            className="print-muted"
            fontSize="lede"
            lineHeight={1.3}
            color="ink.light2"
            maxW="34ch"
            sx={{ textWrap: "pretty" }}
          >
            {FEATURE.desc}
          </Text>
          <AppLink
            href={FEATURE.linkHref}
            mt="6px"
            justifySelf="start"
            display="inline-flex"
            alignItems="center"
            gap="12px"
            pb="6px"
            minH="44px"
            borderBottom="1px solid"
            borderColor="rgba(245, 243, 240, 0.3)"
            fontSize="small"
            letterSpacing="0.06em"
            textTransform="uppercase"
            color="brand.500"
            transitionProperty="color, border-color"
            transitionDuration="0.25s"
            transitionTimingFunction="brand"
            _hover={{ color: "brand.500", borderColor: "brand.500" }}
          >
            <Box as="span">{FEATURE.linkLabel}</Box>
            <Box as="span" aria-hidden="true">
              →
            </Box>
          </AppLink>
        </Grid>
      </Grid>
    </Reveal>
  </Box>
);
